import React from "react";

// Launch splash: the "LiveLife" wordmark rises in first, then the yellow spark
// above the "i" flies down from the top and lands in place. Purely presentational;
// the app loads underneath and the overlay fades out after ~2s.
export default function Splash({ done }) {
  return (
    <div
      data-testid="app-splash"
      aria-hidden="true"
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-white transition-opacity duration-500 ${done ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <div className="relative w-52 sm:w-72 select-none">
        <img src="/splash-base.png" alt="" draggable="false" className="w-full splash-wordmark" />
        <img src="/splash-spark.png" alt="" draggable="false" className="absolute inset-0 w-full splash-spark" />
      </div>
    </div>
  );
}
